import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';

class MessageModal extends React.Component {
  state = {
    origin: 'https://e-spdp.pl'
  };

  componentDidMount() {
    this.setState({
      origin: window.location.origin
    });
  }

  render() {
    const { origin } = this.state;

    const { message, messageText, openModal, closeModal, teryt } = this.props;

    const parcelsText = (messageText || []).join('; ');

    const MESSAGE_TYPES = {
      PARCEL_NOT_FOUND: 1,
      NO_MPZP_COVERAGE: 2,
      REDIRECT_TO_MPZP: 3,
      HAS_MPZP_COVERAGE: 4,
      NO_POG_COVERAGE: 5,
    };

    const MESSAGE_CONTENT = {
      [MESSAGE_TYPES.PARCEL_NOT_FOUND]: (
        <h4>
          Wybrano działkę, która nie istnieje bądź leży poza terenem gminy
        </h4>
      ),

      [MESSAGE_TYPES.NO_MPZP_COVERAGE]: (
        <div>
          <h4>Poniższe działki nie mają pokrycia w MPZP:</h4>
          <i style={{ textAlign: 'justify' }}>{parcelsText}</i>
        </div>
      ),

      [MESSAGE_TYPES.REDIRECT_TO_MPZP]: (
        <h4>
          Jeżeli nieruchomość położona jest w granicach miejscowego planu
          zagospodarowania przestrzennego, należy skorzystać z usługi{' '}
          <a
            href={`${origin}/eservices?district=${teryt}&serviceType=WypisIWyrysZMpzp`}
          >
            wypisu i wyrysu z miejscowego planu zagospodarowania przestrzennego
          </a>.
        </h4>
      ),

      [MESSAGE_TYPES.HAS_MPZP_COVERAGE]: (
        <div>
          <h4>Poniższe działki posiadają pokrycie w MPZP:</h4>
          <i style={{ textAlign: 'justify' }}>{parcelsText}</i>
        </div>
      ),

      [MESSAGE_TYPES.NO_POG_COVERAGE]: (
        <div>
          <h4>Poniższe działki nie mają pokrycia w planie ogólnym gminy:</h4>
          <i style={{ textAlign: 'justify' }}>{parcelsText}</i>
        </div>
      ),
    };

    return (
      <Modal show={openModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Komunikat</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {MESSAGE_CONTENT[message] || null}
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={closeModal}>Zamknij</Button>
        </Modal.Footer>
      </Modal>
    );
  }
};

MessageModal.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default MessageModal;



// WEBPACK FOOTER //
// src/routes/eservices/MessageModal.js